export default __webpack_public_path__ + "static/media/draw_black.c289eb35.svg";